"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var Switch = _interopRequireWildcard(require("@radix-ui/react-switch"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _animations = require("../../styles/animations");
var _mixins = require("../../styles/mixins");
var _framerMotion = require("framer-motion");
var _HBTooltip = _interopRequireDefault(require("../HBTooltip/HBTooltip"));
var _useBuildTestIdInternal = require("../common/internal/useBuildTestIdInternal");
var _Check = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check12"));
var _Check2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/Check8"));
var _LineSingle = _interopRequireDefault(require("@honeybook/icons/dist/icons/LineSingle12"));
var _LineSingle2 = _interopRequireDefault(require("@honeybook/icons/dist/icons/LineSingle8"));
var _excluded = ["size", "checked"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
/* ------------------------------ Constants ------------------------------ */

var CHECKED_ICONS = {
  sm: _Check2["default"],
  md: _Check2["default"],
  lg: _Check["default"]
};
var UNCHECKED_ICONS = {
  sm: _LineSingle2["default"],
  md: _LineSingle2["default"],
  lg: _LineSingle["default"]
};
var SIZES = {
  sm: {
    width: '28px',
    height: '16px',
    thumbSize: '12px',
    thumbOffset: '2px',
    checkRatio: '12px'
  },
  md: {
    width: '34px',
    height: '20px',
    thumbSize: '14px',
    thumbOffset: '3px',
    checkRatio: '14px'
  },
  lg: {
    width: '42px',
    height: '24px',
    thumbSize: '18px',
    thumbOffset: '3px',
    checkRatio: '18px'
  }
};
var SWITCH_COLORS = {
  checked: {
    "default": _colors["default"].textPrimary,
    hover: _colors["default"].textSecondary,
    disabled: _colors["default"].surfaceDisabled
  },
  unchecked: {
    "default": _colors["default"].textTertiary,
    hover: _colors["default"].textSecondary,
    disabled: _colors["default"].surfaceDisabled
  },
  error: {
    surface: _colors["default"].danger100,
    border: _colors["default"].red500,
    icon: _colors["default"].surfaceItem
  }
};
var THUMB_COLORS = {
  "default": _colors["default"].surfaceItem,
  disabled: _colors["default"].surfaceItem,
  error: _colors["default"].red500
};

/* ------------------------------ Types ------------------------------ */

/* ------------------------------ Component ------------------------------ */

function HBSwitch(_ref) {
  var id = _ref.id,
    name = _ref.name,
    testIdName = _ref.testIdName,
    testId = _ref.testId,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'sm' : _ref$size,
    checked = _ref.checked,
    onChange = _ref.onChange,
    disabled = _ref.disabled,
    disabledTooltipText = _ref.disabledTooltipText,
    disabledTooltipProps = _ref.disabledTooltipProps,
    label = _ref.label,
    className = _ref.className,
    _ref$hideCheckIcon = _ref.hideCheckIcon,
    hideCheckIcon = _ref$hideCheckIcon === void 0 ? false : _ref$hideCheckIcon,
    toolTipText = _ref.toolTipText,
    toolTipProps = _ref.toolTipProps,
    _ref$error = _ref.error,
    error = _ref$error === void 0 ? false : _ref$error;
  var animationVariants = (0, _react.useMemo)(function () {
    return getAnimationVariants(size);
  }, [size]);
  var finalTestId = (0, _useBuildTestIdInternal.useBuildTestIdInternal)({
    testId: testId,
    identifier: testIdName || id || name,
    suffix: 'switch-label',
    componentName: 'HBSwitch'
  });
  var actualToolTipProps = disabled ? disabledTooltipProps : toolTipProps;
  var actualToolTipText = disabled ? disabledTooltipText : toolTipText;
  var switchCmp = /*#__PURE__*/_react["default"].createElement(Root, {
    id: id,
    name: name,
    size: size,
    checked: checked,
    disabled: disabled,
    error: error,
    onCheckedChange: onChange,
    "data-testid": finalTestId,
    className: className
  }, /*#__PURE__*/_react["default"].createElement(Thumb, {
    size: size,
    checked: checked,
    initial: false,
    animate: checked ? 'checked' : 'unchecked',
    variants: animationVariants,
    "aria-label": checked ? "".concat(label, " on") : "".concat(label, " off"),
    error: error,
    disabled: disabled
  }), !hideCheckIcon && /*#__PURE__*/_react["default"].createElement(Check, {
    size: size,
    disabled: disabled,
    checked: checked,
    error: error
  }));
  return (
    /*#__PURE__*/
    // When tooltip is disabled it will render the target only. We only show a tooltip here when the switch
    // is disabled.
    _react["default"].createElement(_HBTooltip["default"], (0, _extends2["default"])({
      target: switchCmp,
      placement: "top",
      disabled: !disabled && !toolTipText,
      offsetY: 6,
      targetContainerStyle: targetContainerStyle
    }, actualToolTipProps), actualToolTipText)
  );
}
var _default = exports["default"] = HBSwitch;
/* ------------------------------ Helpers ------------------------------ */
var targetContainerStyle = {
  display: 'inline-flex'
};
function sizeProp(prop) {
  return function (_ref2) {
    var size = _ref2.size;
    return SIZES[size][prop];
  };
}
function getBackgroundColor(_ref3) {
  var checked = _ref3.checked,
    disabled = _ref3.disabled,
    error = _ref3.error;
  // no hover interaction when disabled
  if (disabled) {
    return (0, _styledComponents.css)(["background-color:", ";"], checked ? SWITCH_COLORS.checked.disabled : SWITCH_COLORS.unchecked.disabled);
  }
  if (error) {
    return (0, _styledComponents.css)(["background-color:", ";box-shadow:0 0 0 1px ", " inset;"], SWITCH_COLORS.error.surface, SWITCH_COLORS.error.border);
  }
  return (0, _styledComponents.css)(["", ";"], (0, _animations.hoverTransition)('background-color', checked ? SWITCH_COLORS.checked["default"] : SWITCH_COLORS.unchecked["default"], checked ? SWITCH_COLORS.checked.hover : SWITCH_COLORS.unchecked.hover, undefined, undefined, false));
}
function getAnimationVariants(size) {
  // This works, but the more correct thing is to have right: SIZES[size].thumbOffset here
  // using right doesn't animate in this current version of framer-motion
  // it does work in the latest version, but, that has issues with our webpack build in
  // honeybook-react.
  // TL;DR - when framer-motion is updated to v6, change this to: right: SIZES[size].thumbOffset
  return {
    checked: {
      left: "calc(100% - ".concat(parseInt(SIZES[size].thumbOffset) + parseInt(SIZES[size].thumbSize), "px)")
    },
    unchecked: {
      left: "".concat(SIZES[size].thumbOffset)
    }
  };
}

/* ------------------------------ Root ------------------------------ */
var Root = (0, _styledComponents["default"])(Switch.Root).withConfig({
  displayName: "HBSwitch__Root",
  componentId: "sc-vefmw6-0"
})(["&&&{min-width:", ";height:", ";border-radius:", ";border:none;position:relative;padding:0;cursor:", ";box-sizing:content-box;", ";", ";}&&&:focus-visible{", ";}", " svg *{fill:", ";}&:hover{svg *{fill:", ";}}"], sizeProp('width'), sizeProp('height'), sizeProp('width'), function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, getBackgroundColor, _mixins.revertOutlineForFocusVisible, getBackgroundColor, (0, _mixins.focusState)(), function (_ref5) {
  var checked = _ref5.checked,
    error = _ref5.error,
    disabled = _ref5.disabled;
  if (error && !disabled) {
    return SWITCH_COLORS.error.surface;
  }
  if (checked) {
    return disabled ? SWITCH_COLORS.checked.disabled : SWITCH_COLORS.checked["default"];
  }
  return disabled ? SWITCH_COLORS.unchecked.disabled : SWITCH_COLORS.unchecked["default"];
}, function (_ref6) {
  var checked = _ref6.checked,
    error = _ref6.error,
    disabled = _ref6.disabled;
  if (disabled) {
    return;
  }
  if (error) {
    return SWITCH_COLORS.error.surface;
  }
  if (checked) {
    return SWITCH_COLORS.checked.hover;
  }
  return SWITCH_COLORS.unchecked.hover;
});

/* ------------------------------ Thumb ------------------------------ */
var Thumb = (0, _styledComponents["default"])((0, _framerMotion.motion)(Switch.Thumb, {
  forwardMotionProps: true
})).withConfig({
  displayName: "HBSwitch__Thumb",
  componentId: "sc-vefmw6-1"
})(["", ";height:", ";width:", ";border-radius:", ";background-color:", ";", " ", ""], _mixins.absoluteCenteredVertical, sizeProp('thumbSize'), sizeProp('thumbSize'), sizeProp('thumbSize'), THUMB_COLORS["default"], function (_ref7) {
  var error = _ref7.error;
  return error && (0, _styledComponents.css)(["background-color:", ";"], THUMB_COLORS.error);
}, function (_ref8) {
  var disabled = _ref8.disabled;
  return disabled && (0, _styledComponents.css)(["background-color:", ";"], THUMB_COLORS.disabled);
});

/* ------------------------------ Check Icon ------------------------------ */
var Check = (0, _styledComponents["default"])(function (_ref9) {
  var size = _ref9.size,
    checked = _ref9.checked,
    props = (0, _objectWithoutProperties2["default"])(_ref9, _excluded);
  var CheckComponent = checked ? CHECKED_ICONS[size] : UNCHECKED_ICONS[size];
  return /*#__PURE__*/_react["default"].createElement(CheckComponent, props);
}).withConfig({
  displayName: "HBSwitch__Check",
  componentId: "sc-vefmw6-2"
})(["", ";line-height:0;position:absolute;opacity:0;animation:", " 0.4s ease-in-out forwards;width:", ";height:", ";top:", ";", ";"], _mixins.flexCenterAll, _animations.fadeIn, sizeProp('checkRatio'), sizeProp('checkRatio'), sizeProp('thumbOffset'), function (_ref0) {
  var checked = _ref0.checked;
  return checked ? (0, _styledComponents.css)(["right:", ";left:auto;"], sizeProp('thumbOffset')) : (0, _styledComponents.css)(["left:", ";right:auto;"], sizeProp('thumbOffset'));
});
//# sourceMappingURL=HBSwitch.js.map